import AnnualPND1ReportComponent from "features/Report/components/SalaryGroup/AnnualPND1Report";
import useAnnualPND1Report from "features/Report/hooks/salaryGroup/useAnnualPND1Report";

const AnnualPND1ReportPage = () => {
    const annualPND1ReportProps = useAnnualPND1Report();
    return <AnnualPND1ReportComponent {...annualPND1ReportProps} />
}

export default AnnualPND1ReportPage;